import { render, staticRenderFns } from "./inventoryItemsBox.vue?vue&type=template&id=0cbeae33&"
import script from "./inventoryItemsBox.vue?vue&type=script&lang=ts&"
export * from "./inventoryItemsBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports